exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-box .my-card {\n  margin-bottom: 10px;\n}\n.my-box .el-row {\n  margin-bottom: 10px;\n}\n.my-box .el-row:last-child {\n    margin-bottom: 0;\n}\n.my-box .el-col {\n  border-radius: 4px;\n}\n.my-box .grid-content {\n  border-radius: 4px;\n  height: 36px;\n  white-space: nowrap;\n}\n.my-box .grid-content .el-input__inner {\n    max-width: 190px;\n}\n.my-box .grid-content span {\n    font-size: 14px;\n}\n", ""]);

// exports
